<template>
  <div v-if="data && data.config">
    <el-button v-if="isDev" @click="testSubmit">保存测试</el-button>
    <el-form
      class="el-form-drawer-bind"
      @submit.native.prevent
      ref="generateForm"
      :class="{
        [data.config.customClass]: data.config.customClass ? true : false,
        swLabelCenter: data.config.labelPosition === 'center',
      }"
      :size="data.config.size"
      :model="models"
      :label-position="data.config.labelPosition"
      :label-width="data.config.labelWidth + 'px'"
      :rules="rules"
    >
      <template v-for="(item, index) in data.list">
        <generate-advanced-item
          v-if="Object.keys(advancedComponents).indexOf(item.type) >= 0"
          :key="item.key"
          :models.sync="models"
          :rules="rules"
          :widget="item"
          :remote="remote"
          :from-son-form="false"
          :data="data"
          :is-mobile="isMobile"
        ></generate-advanced-item>

        <generate-son-form
          v-else-if="
            item.type === 'sonform' && item.options && !item.options.hidden
          "
          :key="item.key"
          :model.sync="models"
          :rules="rules"
          :element="item"
          :remote="remote"
          :data="data"
          :approveTip="approveTip"
          :dataType="dataType"
          :is-mobile="isMobile"
          :instanceJson="remoteFormData?.instanceJson"
          :ffid="ffid"
          :yyid="yyid"
        ></generate-son-form>

        <generate-report
          v-else-if="item.type === 'report'"
          :key="item.key"
          :model.sync="models"
          :rules="rules"
          :element="item"
          :data="data"
          :remote="remote"
          :instanceJson="remoteFormData?.instanceJson"
          :approveTip="approveTip"
          :dataType="dataType"
          :is-mobile="isMobile"
          :ffid="ffid"
          :yyid="yyid"
        ></generate-report>
        <generate-col-item
          v-else-if="item.type === 'grid'"
          :key="item.key"
          :model.sync="models"
          :rules="rules"
          :element="item"
          :data="data"
          :remote="remote"
          :is-mobile="isMobile"
          :approveTip="approveTip"
          :dataType="dataType"
          :nodeConfig="nodeConfig"
          :instanceJson="remoteFormData?.instanceJson"
          :ffid="ffid"
          :yyid="yyid"
        ></generate-col-item>
        <div
          v-else-if="item.type === 'comment' && item.options.showOthersComment"
          :key="index"
        >
          <generate-comment-item
            v-if="!item.options.hidden"
            :key="item.key"
            :model.sync="models[item.model]"
            :rules="rules"
            :nodeConfig="nodeConfig"
            :currentUser="currentUser"
            :element="item"
            :data="data"
            :remote="remote"
          ></generate-comment-item>
          <generate-comment-read-item
            v-if="!item.options.hidden"
            :key="item.key + 'read'"
            :model.sync="models[item.model]"
            :rules="rules"
            :element="item"
            :data="data"
            :remote="remote"
          ></generate-comment-read-item>
        </div>
        <div
          v-else-if="item.type === 'comment' && !item.options.showOthersComment"
          :key="index"
        >
          <!-- !item.options.hidden && -->
          <generate-comment-item
            v-if="
              item.type === 'comment' &&
              !(disabled || item.options.disabled) &&
              !item.options.hidden
            "
            :key="item.key"
            :model.sync="models[item.model]"
            :rules="rules"
            :nodeConfig="nodeConfig"
            :currentUser="currentUser"
            :element="item"
            :data="data"
            :remote="remote"
          ></generate-comment-item>
          <!-- !item.options.hidden && -->
          <generate-comment-read-item
            v-if="
              item.type === 'comment' &&
              (disabled || item.options.disabled) &&
              !item.options.hidden
            "
            :key="item.key"
            :model.sync="models[item.model]"
            :rules="rules"
            :nodeConfig="nodeConfig"
            :currentUser="currentUser"
            :element="item"
            :data="data"
            :remote="remote"
          ></generate-comment-read-item>
        </div>
        <generate-form-item
          v-else
          :ref="'generateFormItemRef' + item.key"
          :key="item.key"
          :models.sync="models"
          :rules="rules"
          :widget="item"
          :remote="remote"
          :from-son-form="false"
          :data="data"
          :is-mobile="isMobile"
          :approveTip="approveTip"
          :dataType="dataType"
          :remoteOrganization="remoteOrganization"
          :nodeConfig="nodeConfig"
          :instanceJson="remoteFormData?.instanceJson"
          :ffid="ffid"
          :yyid="yyid"
        ></generate-form-item>
      </template>
    </el-form>
    <el-dialog
      title="提示"
      :visible.sync="eventConfig.alertConfig.isShow"
      width="30%"
      :before-close="handleClose"
    >
      <div v-html="eventConfig.alertConfig.alertHtml"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="eventConfig.alertConfig.isShow = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="eventConfig.alertConfig.isShow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GenerateCommentItem from './Comment/index'
import GenerateCommentReadItem from './Comment/readonly'
import GenerateReport from './GenerateReport'
import { advancedComponents } from './advanced/advanced.js'
import FlowFromApi from './api/FlowFromApi'
import eventUtils from '../util/eventUtils'
import generateUtils from '../util/generateUtils'
// import formUtils from '../util/formUtils'
import moduleUtils from '../util/moduleUtils'
import bus from '../util/eventBus'
import globalBus from '../util/globalBus'
import alertUtils from '../util/alertUtils'
import { config } from '../config/config'
// import generateApi from '../components/api/generateApi'
export default {
  name: 'fm-generate-form',
  components: {
    GenerateCommentItem,
    GenerateCommentReadItem,
    GenerateReport,
  },
  props: [
    'remoteFormData',
    'fid',
    'ffid',
    'yyid',
    'taskId',
    'dataType',
    'draftId',
    'formDataId',
    'formDataVersion',
    'widgetForm',
    'remote',
    'value',
    'currentUser',
    'previewBaseApi',
    'fileBaseApi',
    'baseApi',
    'token',
    'customJs',
    'disabled',
    'approveTip',
    'showData',
    'fontSize',
    'globalLabelWidth',
  ],
  data() {
    return {
      advancedComponents,
      data: this.widgetForm,
      models: {},
      rules: {},
      flowFormManager: {
        version: '',
        actFormId: '',
        actFormName: '',
        actDefId: '',
        deployId: '',
      },
      subContent: {
        userName: this.currentUser ? this.currentUser.username : 'admin', // 后面从token 获取
        taskId: '',
        moduleJson: '',
        instanceJson: '',
        variables: '',
      },
      nodeConfig: {}, // 节点属性配置 eg: 必填、禁用、隐藏、初始化
      nodePageConfig: {}, // 子页面查看删除编辑权限控制
      eventConfig: {
        alertConfig: {
          isShow: false,
          alertHtml: '',
        },
      },
      ready: false,
      isMobile: false, // 是否是手机
      screenWidth: document.body.clientWidth,
      isDev: process.env.NODE_ENV === 'development',
      queryDataList: [],
      initdata: 'initialize',
      remoteOrganization: [], // 组织机构列表(处理好的数据)
    }
  },
  created() {
    window.globalBus = globalBus
    this.initConfig()
    this.initData()
    this.initEvents()
    if (this.showData === 'initialize' || this.initdata === 'initialize') {
      // 有该属性时：初始化数据
      this.dupData.forEach(item => {
        generateUtils.queryFormService(item, this.queryDataList)
      })
    }
  },

  mounted() {
    const that = this
    window.onresize = () => {
      // 根据窗口宽度-移动自适应调整
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        generateUtils.adaptive(
          that.screenWidth,
          this.data.config,
          this.isMobile
        )
      })()
    }
  },
  provide() {
    return {
      validateKey: this.validateKey,
    }
  },
  computed: {
    // 去除相同的接口
    dupData() {
      const remoteUrlList = []
      if (this.data && this.data.list && this.data.list.length) {
        generateUtils.handleInitRemoteUrl(this.data.list, remoteUrlList)
      }
      const dupData = []
      for (let i = 0; i < remoteUrlList.length; i++) {
        for (let j = i + 1; j < remoteUrlList.length; j++) {
          if (
            remoteUrlList[i].options.remoteUrl ===
            remoteUrlList[j].options.remoteUrl
          ) {
            i++
            j = i
          }
        }
        dupData.push(remoteUrlList[i])
      }
      return dupData
    },
  },
  methods: {
    resetDateField(key) {
      if (this.$refs['generateFormItemRef' + key]) {
        this.$refs['generateFormItemRef' + key][0].resetDateField()
      }
    },
    initLocalEvents() {
      // 统一处理事件
      bus.$on('eventMethod', this.acceptEventMethod)
      // 统一子表单处理事件
      bus.$on('sonEventMethod', this.acceptSonEventMethod)
      bus.$on('changeModels', this.acceptChangeModels)
    },
    initGlobalEvents() {
      globalBus.$on('changeOptions', this.acceptChangeOptions)
      globalBus.$on('findData', this.acceptFindData)
      globalBus.$on('validate', this.acceptValidate)
      globalBus.$on('getInstanceData', this.acceptGetInstanceData)
    },
    destroyEvent() {
      // 统一处理事件
      bus.$off('eventMethod', this.acceptEventMethod)
      // 统一子表单处理事件
      bus.$off('sonEventMethod', this.acceptSonEventMethod)
      bus.$off('changeModels', this.acceptChangeModels)
      globalBus.$off('changeOptions', this.acceptChangeOptions)
      globalBus.$off('findData', this.acceptFindData)
      globalBus.$off('validate', this.acceptValidate)
      globalBus.$off('getInstanceData', this.acceptGetInstanceData)
    },
    acceptEventMethod(params) {
      this.eventMessageDetail(params)
    },
    acceptSonEventMethod(params) {
      this.sonFormEventMessageDetail(params)
    },
    acceptChangeModels(params) {
      this.models = Object.assign(this.models, params)
    },
    acceptChangeOptions(data) {
      moduleUtils.changeWidget(this.data.list, data, 'changeOptions')
      this.$emit('custom-change-options', this.data.list)
    },
    acceptFindData(model) {
      if (model) {
        const item = { model: model }
        moduleUtils.changeWidget(this.data.list, item, 'getData', this)
      } else {
        globalBus.$emit('getData', this.data.list)
      }
    },
    acceptGetInstanceData(callback) {
      callback(JSON.parse(JSON.stringify(this.models)))
    },
    acceptValidate(model) {
      if (model) {
        this.$refs.generateForm.validateField(model)
      } else {
        this.$refs.generateForm.validate(valid => {
          if (!valid) {
            this.$emit('scroll-to-error')
          }
        })
      }
    },
    setModelsData(data, models) {
      if (Object.prototype.hasOwnProperty.call(models, data.model)) {
        models[data.model] = data.value
        return
      }
      for (const key in models) {
        const val = models[key]
        if (!Array.isArray(val)) {
          continue
        }
        val.forEach(v => {
          if (Object.prototype.toString.call(v) === '[object Object]') {
            this.setModelsData(data, v)
          }
        })
      }
    },
    initEvents() {
      this.initLocalEvents()
      this.initGlobalEvents()
    },
    initData() {
      // process.env.NODE_ENV === 'development' ? this.initDev() : this.initFormData()
      this.initFormData()
    },
    initDev() {
      this.isDev = true
      if (config.pageType === 'write') {
        this.getJsonByFidOnDev(config.fid)
      }
      if (config.pageType === 'draft') {
        this.getJsonByDraft(config.id)
      }
      if (config.pageType === 'handle') {
        if (config.taskId) {
          this.getJsonByFFidOnDev(config.ffid, config.taskId)
        } else {
          this.getJsonByFFidNoTaskIdOnDev(config.ffid)
        }
      }
      if (config.pageType === 'design') {
        this.initFormData()
      }
    },
    validateKey(key) {
      this.$nextTick(() => {
        this.$refs.generateForm.validateField(key)
      })
    },

    initConfig() {
      if (
        this.fileBaseApi &&
        this.fileBaseApi.toLowerCase().indexOf('http') > -1
      ) {
        config.fileBaseAPI = this.fileBaseApi
      }
      if (
        this.previewBaseApi &&
        this.previewBaseApi.toLowerCase().indexOf('http') > -1
      ) {
        config.previewBaseApi = this.previewBaseApi
      }
      if (this.baseApi && this.baseApi.toLowerCase().indexOf('http') > -1) {
        config.baseAPI = this.baseApi
      }
      if (this.token) {
        config.token = this.token
      }
    },
    initFormData() {
      this.models = {}
      this.rules = {}
      switch (this.dataType) {
        case 'detail':
          this.initDetailForm()
          break
        case 'write':
          this.initWriteForm()
          break
        case 'supply':
          this.initSupplyForm()
          break
        case 'handle':
          this.initHandleForm()
          break
        case 'looking':
          this.initHandleForm()
          break
        default:
          this.initPreview()
      }
    },
    initDetailForm() {
      // 获取远程 表单 所有的json  用于 表单设计器修改
      const remoteData = JSON.parse(JSON.stringify(this.remoteFormData))
      if (
        remoteData &&
        remoteData.list &&
        remoteData.config &&
        remoteData.list.length > 0
      ) {
        this.data = remoteData
        if (this.data && this.data.list && this.data.list.length > 0) {
          this.generateModel(this.data.list)
        } else {
          alertUtils.alertError('查询远程数据异常', true)
        }
      }
    },
    initWriteForm() {
      this.data = this.remoteFormData.moduleJson
      if (this.data.config) {
        this.data.config.width = document.body.clientWidth
      }

      this.nodeConfig = this.remoteFormData.bd
      this.nodePageConfig = this.remoteFormData.bdPage
      this.flowFormManager.actFormId = this.fid
      this.flowFormManager.version = this.remoteFormData.ffVersion
      this.flowFormManager.actFormName = this.remoteFormData.ffName
      this.flowFormManager.actDefId = this.remoteFormData.actId
      if (this.data && this.data.list && this.data.list.length > 0) {
        this.renderInstanceToWidget(
          this.data.list,
          this.remoteFormData.instanceJson
        )
        this.renderFormNodeConfig(this.data.list)
        this.generateModel(this.data.list)
        this.getOrganizationList(this.data)
      } else {
        alertUtils.alertError('查询数据异常', true)
      }
    },
    initSupplyForm() {
      this.data = JSON.parse(this.remoteFormData.data.moduleJson)
      this.data.config.width = document.body.clientWidth
      this.subContent.taskId = this.remoteFormData.taskId
      if (this.data && this.data.list && this.data.list.length > 0) {
        this.renderFormNodeConfig(this.data.list)
        this.generateModel(this.data.list)
        this.getOrganizationList(this.data)
      } else {
        alertUtils.alertError('查询数据异常', true)
      }
    },
    initHandleForm() {
      this.flowFormManager.actFormId = this.fid
      this.flowFormManager.version = this.remoteFormData.ffVersion
      this.flowFormManager.actFormName = this.remoteFormData.ffName
      this.flowFormManager.actDefId = this.remoteFormData.actId
      this.flowFormManager.deployId = this.remoteFormData.deployId
      this.subContent.taskId = this.taskId
      this.data = this.remoteFormData.moduleJson
      this.data.config.width = document.body.clientWidth
      this.nodeConfig = this.remoteFormData.bd
      this.nodePageConfig = this.remoteFormData.bdPage
      if (this.data && this.data.list && this.data.list.length > 0) {
        this.renderInstanceToWidget(
          this.data.list,
          this.remoteFormData.instanceJson
        )
        this.renderFormNodeConfig(this.data.list)
        this.generateModel(this.data.list)
        this.getOrganizationList(this.data)
      } else {
        alertUtils.alertError('查询数据异常', true)
      }
    },
    initPreview() {
      this.generateModel(this.data.list, 'preview')
      this.getOrganizationList(this.data)
    },
    flushCachedData() {
      // 刷新页面所有缓存数据， 预防数据不是最新数据
      generateUtils.flushCachedData(this.data.list)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    generateModel(genList, type) {
      // 初始化 mode 属性
      this.isMobile = generateUtils.isMobile() // 判断是否是移动端访问
      generateUtils.adaptive(this.screenWidth, this.data.config, this.isMobile) // 调整 标题摆放位置
      this.data.config.disabled = this.disabled
      moduleUtils.generateFormModel(
        genList,
        this.value,
        this.models,
        this.rules,
        type
      )
      console.log('551-this.models', this.models)
      this.freeDomJs()
    },
    renderFormNodeConfig(list) {
      // 渲染设置流程节点配置项
      if (this.nodeConfig) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].type === 'grid') {
            list[i].columns.forEach(item => {
              if (item.list) this.renderFormNodeConfig(item.list)
            })
          } else if (list[i].type === 'report') {
            // 中国式表格
            list[i].rows.forEach(row => {
              row.columns.forEach(column => {
                if (column.list) this.renderFormNodeConfig(column.list)
              })
            })
          } else if (list[i].type === 'sonform') {
            if (Object.keys(this.nodeConfig).indexOf(list[i].model) >= 0) {
              // 找到对应字段
              const nodeConfig = this.nodeConfig[list[i].model]
              if (nodeConfig) {
                moduleUtils.editModule(
                  list[i],
                  nodeConfig,
                  this.currentUser,
                  this.data.config.fixHiddenDom
                ) // 具体组件配置
              }
            }
            if (list[i].list) {
              this.renderFormNodeConfig(list[i].list)
            }
            const tableLists = list[i].tableLists
            if (tableLists && tableLists.length) {
              tableLists.forEach(tbList => {
                if (tbList) this.renderFormNodeConfig(tbList)
              })
            }
          } else if (list[i].type === 'page') {
            const selectPageKey = list[i].options.selectPage
            if (!selectPageKey) {
              return
            }
            if (this.nodePageConfig) {
              const pageControl = this.nodePageConfig[list[i].model]
              this.$set(list[i].options, 'pageControl', pageControl)
            }
            const sonPageList = this.data.sonPages[selectPageKey].list
            if (sonPageList) this.renderFormNodeConfig(sonPageList)
          } else if (Object.keys(this.nodeConfig).indexOf(list[i].model) >= 0) {
            // 找到对应字段
            const nodeConfig = this.nodeConfig[list[i].model]
            if (nodeConfig) {
              moduleUtils.editModule(
                list[i],
                nodeConfig,
                this.currentUser,
                this.data.config.fixHiddenDom
              ) // 具体组件配置
            }
          }
        }
      }
    },
    renderInstanceToWidget(list, instance) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].type === 'grid') {
          list[i].columns.forEach(item => {
            if (item.list) this.renderInstanceToWidget(item.list, instance)
          })
        } else if (list[i].type === 'report') {
          // 中国式表格
          list[i].rows.forEach(row => {
            row.columns.forEach(column => {
              if (column.list)
                this.renderInstanceToWidget(column.list, instance)
            })
          })
        } else if (list[i].type === 'sonform') {
          if (Object.keys(instance).indexOf(list[i].model) >= 0) {
            // 找到对应字段
            const value = instance[list[i].model]
            if (value) {
              list[i].sonValues = value
            }
          }
          // this.renderInstanceToWidget(list[i].list, instance)
        } else if (Object.keys(instance).indexOf(list[i].model) >= 0) {
          // 找到对应字段
          if (list[i].model.indexOf('divider') > -1) {
            return
          }

          const value = instance[list[i].model]

          if (value || value === 0) {
            list[i].options.defaultValue = value
            list[i].options.value = value
          }
        }
      }
    },
    getData() {
      // 获取 models
      return new Promise((resolve, reject) => {
        this.$refs.generateForm.validate(valid => {
          if (valid) {
            resolve(this.models)
          } else {
            reject(new Error('表单数据校验失败').message)
          }
        })
      })
    },
    getAllInfoData() {
      // 获取 页面所有数据
      return new Promise((resolve, reject) => {
        this.$refs.generateForm.validate(valid => {
          if (valid) {
            this.subContent.moduleJson = this.data
            this.subContent.instanceJson = moduleUtils.generateDataInstanceJson(
              this.models
            )
            const jsonObj = {
              ffid: this.ffid,
              main: this.flowFormManager,
              subContent: this.subContent,
            }
            resolve(jsonObj)
          } else {
            reject(new Error('表单数据校验失败').message)
          }
        })
      })
    },
    getAllInfoDataHasRemoteNoValidate() {
      // 获取 页面所有非远程数据
      return new Promise(resolve => {
        this.subContent.moduleJson = this.data
        this.subContent.instanceJson = moduleUtils.generateDataInstanceJson(
          this.models
        )
        this.subContent.labelJson = moduleUtils.generateLabelJson(
          this.data,
          this.subContent.instanceJson
        )
        console.log(this.subContent.labelJson)
        const jsonObj = {
          ffid: this.ffid,
          main: this.flowFormManager,
          subContent: this.subContent,
        }
        resolve(jsonObj)
      })
    },
    getAllInfoDataNoRemote(returnToCirculation) {
      // returnToCirculation 退回流转 不进行必填校验
      if (returnToCirculation == 'true') {
        return new Promise(resolve => {
          this.subContent.moduleJson = moduleUtils.generateNoRemoteModuleJson(
            this.data
          )
          this.subContent.instanceJson = moduleUtils.generateDataInstanceJson(
            this.models
          )
          const jsonObj = {
            ffid: this.ffid,
            main: this.flowFormManager,
            subContent: this.subContent,
          }
          resolve(jsonObj)
        })
      } else {
        // 获取 页面所有非远程数据
        return new Promise((resolve, reject) => {
          this.$refs.generateForm.validate(valid => {
            if (valid) {
              this.subContent.moduleJson =
                moduleUtils.generateNoRemoteModuleJson(this.data)
              this.subContent.instanceJson =
                moduleUtils.generateDataInstanceJson(this.models)
              const jsonObj = {
                ffid: this.ffid,
                main: this.flowFormManager,
                subContent: this.subContent,
              }
              // console.log(
              //   this.subContent.instanceJson,
              //   'this.subContent.instanceJson'
              // )
              resolve(jsonObj)
            } else {
              reject(new Error('表单数据校验失败').message)
            }
          })
        })
      }
    },
    testSubmit() {
      this.getAllInfoDataHasRemoteNoValidate()
        .then(() => {
          // console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAllInfoDataNoValidate() {
      // 获取 页面所有数据 不校验
      return new Promise(resolve => {
        this.subContent.moduleJson = moduleUtils.generateNoRemoteModuleJson(
          this.data
        )
        this.subContent.instanceJson = moduleUtils.generateDataInstanceJson(
          this.models
        )
        const jsonObj = {
          ffid: this.ffid,
          main: this.flowFormManager,
          subContent: this.subContent,
        }
        resolve(jsonObj)
      })
    },
    setFormJson(dataInfo) {
      this.data = dataInfo
      this.generateModel(this.data.list)
    },
    getFormJson() {
      return this.data
    },
    eventMessageDetail(params) {
      // 组件触发事件
      this.$nextTick(() => {
        let models = params.models
        if (!params.fromSonPage) {
          models = Object.assign(params.models || {}, this.models)
        }
        eventUtils.eventStart(
          params.widget,
          params.list,
          models,
          this.eventConfig
        )
      })
    },
    sonFormEventMessageDetail(params) {
      // 子表单组件触发事件
      this.$nextTick(() => {
        eventUtils.sonEventStart(
          params.widget,
          params.lineRow,
          params.models,
          this.eventConfig
        )
      })
    },
    // 自定义事件js
    freeDomJs() {
      if (this.isDev) {
        window.btnBus = globalBus
        if (config.pageType === 'write') {
          this.getWriteFreeJs(config.deployId)
        }
        if (config.pageType === 'handle' && config.taskId) {
          this.getFreeJs(config.taskId)
        }
        return
      }
      if (
        typeof this.customJs !== 'undefined' &&
        this.customJs &&
        this.customJs !== ''
      ) {
        this.$nextTick(() => {
          try {
            eval(this.customJs)
          } catch (error) {
            // eslint-disable-next-line no-console
            console.dir(error)
          }
        })
      }
    },
    getJsonByFFidOnDev(ffid, taskId) {
      // 第一次之后的 方法
      FlowFromApi.getFlowFormInfoConfigByFFid(ffid, taskId)
        .then(response => {
          this.data = response.moduleJson
          this.data.config.width = document.body.clientWidth
          this.flowFormManager.version = response.ffVersion
          this.flowFormManager.actFormName = response.ffName
          this.flowFormManager.actDefId = response.actId
          this.nodeConfig = response.bd
          this.nodePageConfig = response.bdPage
          this.flowFormManager.deployId = response.deployId
          if (this.data && this.data.list && this.data.list.length > 0) {
            this.renderInstanceToWidget(this.data.list, response.instanceJson)

            this.renderFormNodeConfig(this.data.list)

            this.generateModel(this.data.list)
          } else {
            alertUtils.alertError('查询数据异常', true)
          }
        })
        .catch(() => {
          alertUtils.alertError('查询节点配置项异常', true)
        })
    },

    getJsonByFFidNoTaskIdOnDev(ffid) {
      FlowFromApi.getNoFlowFormInfoConfigByFFid(ffid)
        .then(res => {
          const response = res.data
          response.moduleJson = JSON.parse(response.moduleJson)
          response.instanceJson = JSON.parse(response.instanceJson)
          this.data = response.moduleJson
          this.flowFormManager.version = response.ffVersion
          this.flowFormManager.actFormName = response.ffName
          this.flowFormManager.actDefId = response.actId
          this.nodeConfig = response.bd
          this.nodePageConfig = response.bdPage
          this.flowFormManager.deployId = response.deployId
          if (this.data && this.data.list && this.data.list.length > 0) {
            this.renderInstanceToWidget(this.data.list, response.instanceJson)
            this.renderFormNodeConfig(this.data.list)
            this.generateModel(this.data.list)
          } else {
            alertUtils.alertError('查询数据异常', true)
          }
        })
        .catch(() => {
          alertUtils.alertError('查询节点配置项异常', true)
        })
    },
    getJsonByFidOnDev(fid) {
      // 第一次进入页面 方法
      FlowFromApi.getFlowFormConfigByFid(fid)
        .then(response => {
          this.data = response.moduleJson
          this.data.config.width = document.body.clientWidth
          this.flowFormManager.version = response.ffVersion
          this.flowFormManager.actFormName = response.ffName
          this.flowFormManager.actDefId = response.actId
          this.nodeConfig = response.bd
          this.nodePageConfig = response.bdPage
          this.flowFormManager.deployId = response.deployId
          if (this.data && this.data.list && this.data.list.length > 0) {
            this.renderFormNodeConfig(this.data.list)
            this.generateModel(this.data.list)
          } else {
            alertUtils.alertError('查询数据异常', true)
          }
        })
        .catch(e => {
          alertUtils.alertError('申请流程入口查询配置项异常:' + e.message, true)
        })
    },
    getJsonByDraft(id) {
      // 获取草稿json
      FlowFromApi.getDraftJson(id)
        .then(response => {
          this.data = response.data.moduleJson
          // this.data.config.width = document.body.clientWidth
          this.nodeConfig = response.data.bd
          this.nodePageConfig = response.data.bdPage
          this.flowFormManager.actFormId = this.fid
          this.flowFormManager.version = response.data.ffVersion
          this.flowFormManager.actFormName = response.data.ffName
          this.flowFormManager.actDefId = response.data.actId
          if (this.data && this.data.list && this.data.list.length > 0) {
            this.renderFormNodeConfig(this.data.list)
            this.generateModel(this.data.list)
          } else {
            alertUtils.alertError('查询数据异常', true)
          }
        })
        .catch(e => {
          alertUtils.alertError('申请流程入口查询配置项异常:' + e.message, true)
        })
    },
    getWriteFreeJs(defId) {
      FlowFromApi.getWriteFreeJs(defId)
        .then(res => {
          const evejs = res.data.evejs
          eval(evejs)
        })
        .catch(() => {})
    },
    getFreeJs(taskId) {
      FlowFromApi.getFreeJs(taskId).then(res => {
        try {
          const evejs = res.data.evejs
          eval(evejs)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.dir(error)
        }
      })
    },
    // 获取组织机构数据（write、handle、supply、preview页）
    getOrganizationList() {
      // 获取组织机构代码移入userByOrganization文件
      // 下面代码只获取了主页面的第一个组织机构控件，有多个组织机构控件或子表单，栅格组件内，子页面内都无法获取
      // if (widgetForm && widgetForm.list && widgetForm.list.length) {
      //   const userwidget = widgetForm.list.find((item, index) => {
      //     return item.type === 'user' && item.options.useOraganization
      //   })
      //   if (!userwidget) {
      //     return
      //   }
      //   if (!userwidget.options.orgRootId && this.remoteOrganization.length) {
      //     return
      //   }
      //   if (userwidget && !this.remoteOrganization.length) {
      //     // 请求组织机构接口
      //     const params = {}
      //     let url = '/v1/institution/selectInsList'
      //     if (userwidget.options.orgRootId) {
      //       params.id = userwidget.options.orgRootId
      //       url = '/v1/process/getSubAllOrganizations'
      //     }
      //     generateApi.getCustomService(url, params).then(response => {
      //       if (response) {
      //         console.log('params', params)
      //         this.handleOthersService(userwidget, response, userwidget.options.orgRootId)
      //       }
      //     }).catch(e => {
      //       alertUtils.alertError('组织机构选择' + '接口查询错误', true)
      //     })
      //   }
      // }
    },
    handleOthersService(widget, obj, useConfigRootId) {
      const data = eval(
        'obj' +
          (widget.options.props.paramFormat
            ? '.' + widget.options.props.paramFormat
            : '')
      )
      const id = widget.options.props.pk
      const pid = widget.options.props.ppk
      const map = {}
      data.forEach(item => {
        if (useConfigRootId) {
          item.ins_name = item.name
          item.pid = item.parentId
          item.ins_code = item.code
        }
        map[item[id]] = item
      })
      data.forEach(item => {
        const parent = map[item[pid]]
        if (parent) {
          ;(parent.children || (parent.children = [])).push(item)
        } else {
          this.remoteOrganization.push(item)
        }
      })
    },
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.models = { ...this.models, ...val }
      },
    },
    models: {
      deep: true,
      handler() {
        // console.log(`models:${JSON.stringify(val)}`)
      },
    },
    queryDataList: {
      handler(val) {
        this.queryDataList = val
        if (this.queryDataList.length) {
          if (this.data && this.data.list && this.data.list.length) {
            //嵌套组件优化
            generateUtils.handleInit(this.data.list, this.queryDataList)
          }
        }
      },
      deep: true,
      immediate: true,
    },
    fontSize: {
      handler(val) {
        if (
          this.remoteFormData &&
          this.remoteFormData.moduleJson &&
          this.remoteFormData.moduleJson.config
        ) {
          const opt = this.remoteFormData.moduleJson.config
          if (val === '中') {
            this.$set(
              opt,
              'labelWidth',
              this.globalLabelWidth >= 125 ? this.globalLabelWidth : '125'
            )
          } else if (val === '大') {
            this.$set(
              opt,
              'labelWidth',
              this.globalLabelWidth >= 130 ? this.globalLabelWidth : '130'
            )
          } else if (val === '超大') {
            this.$set(
              opt,
              'labelWidth',
              this.globalLabelWidth >= 140 ? this.globalLabelWidth : '140'
            )
          } else {
            this.$set(opt, 'labelWidth', this.globalLabelWidth)
          }
        }
      },
      immediate: true,
    },
    globalLabelWidth: {
      handler() {
        // console.log('this.globalLabelWidth', this.globalLabelWidth)
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.destroyEvent()
  },
}
</script>
<style>
.el-form--label-top .sw-is-mobile .el-form-item__label {
  margin-bottom: -10px;
}
.swLabelCenter .el-form-item__label {
  text-align: center;
}
</style>
<style lang="scss">
/* @import '../styles/cover.scss'; */
</style>
